// Search a business by name, city or phone (GET /api/businesses?q=: setters see only their campaigns' businesses) and
// pick one. Moved out of the Texts page on 2026-10-20 so the Meetings page's "Calendly bookings to link" uses the same
// search (PJ: clear the backlog of bookings the webhook couldn't match).
import './sms.css';
import { useEffect, useState } from 'preact/hooks';
import { errorMessage } from '../api';
import { toast } from '../components/ui';
import { useDebounced } from '../components/ui-extra';
import { endpoints } from './endpoints';
import { fmtPhone } from './labels';
import type { BusinessListItem } from './types';

/** Search a business and pick it: the Texts page files an unmatched conversation under it, the Meetings page links a
 *  Calendly booking to it. `actionLabel` is the button on each result (default "Link"). */
export function LinkBusiness(props: { onPick: (businessId: number, name: string) => Promise<void>; onCancel: () => void; actionLabel?: string }) {
  const [q, setQ] = useState('');
  const dq = useDebounced(q.trim(), 300);
  const [items, setItems] = useState<BusinessListItem[] | null>(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (dq.length < 2) { setItems(null); return; }
    let live = true;
    endpoints.searchLeads({ q: dq, limit: 8 }).then((p) => { if (live) setItems(p.items); }, (e) => toast(errorMessage(e), 'bad'));
    return () => { live = false; };
  }, [dq]);
  return (
    <div class="vd-texts-search">
      <div class="row">
        <input autoFocus value={q} placeholder="Business name, city or phone" aria-label="Search businesses" style="flex:1"
          onInput={(e) => setQ(e.currentTarget.value)} />
        <button class="btn btn-sm" onClick={props.onCancel}>Cancel</button>
      </div>
      {items && !items.length ? <span class="muted" style="font-size:13px">No business matches.</span> : null}
      {items?.length ? (
        <ul>
          {items.map((i) => (
            <li>
              <span>{i.business.name} <span class="muted">{[i.business.city, fmtPhone(i.business.phoneE164)].filter(Boolean).join(' · ')}</span></span>
              <button class="btn btn-sm" disabled={busy} onClick={async () => {
                setBusy(true);
                try { await props.onPick(i.business.id, i.business.name); } finally { setBusy(false); }
              }}>{props.actionLabel ?? 'Link'}</button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
